import { createGlobalState } from "react-hooks-global-states";
import { Profile, User } from "./types";

export const useUser = createGlobalState<User | null>(null);
export const useToken = createGlobalState<string | null>(null);
export const useCurrentProfile = createGlobalState<Profile | null>(null);
